// hero-image

function enable_ratiochecker (){

	function check_16by9(){
		let videos = document.getElementsByClassName ("banner-video");
		let numvideos = videos.length;

		for (let i=0; i<numvideos; i++) {
			if((videos[i].offsetWidth / videos[i].offsetHeight) >= (16/9)){
				videos[i].classList.add("ratio16by9");
			} else {
				videos[i].classList.remove("ratio16by9");
			}
		}
	}

	window.addEventListener('resize', function(event) {
		check_16by9();
	}, true);

	check_16by9();

};

if (document.getElementsByClassName("banner-video").length > 0) {
	enable_ratiochecker();
}

